import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import TopMenu from '../topMenu/TopMenu';
export function BasePage(_a) {
    var children = _a.children;
    return (_jsxs(_Fragment, { children: [_jsx(TopMenu, {}), _jsx(_Fragment, { children: children })] }));
}
